import React, { Component } from 'react';
import { includes } from 'lodash';
import './QuestionForm.scss';
import displayName from '../../../../helpers/displayName';
import { Field } from 'redux-form';
import InfoLabel from '../../../../common/components/InfoLabel/InfoLabel';
import { Button, ButtonBar, HorizontalFormControl } from '../../../../common/components';
import CheckboxUnlabeled from '../../../../common/components/ReduxFormField/CheckboxUnlabeled';

export default class QuestionForm extends Component {
  constructor() {
    super();
  }

  render() {
    const { type, fields } = this.props;

    return (
      <div className="row">
        <div className="col-sm-12">
          <Field
            name={'data.attributes.sections'}
            component={InfoLabel}
            input={{ value: displayName(type) }}
          />
          {fields.map((data, key) => {
            return (
              <div key={key}>
                <div className="row">
                  <div className="col-sm-12">
                    <Field
                      name={'data.attributes.sections.' + `${type}.${key}.question`}
                      label={key + 1 + '.'}
                      labelSize={1}
                      component={HorizontalFormControl}
                    />
                  </div>
                  {includes(type, ['regulation']) && (
                    <div className="col-sm-11 pull-right">
                      <Field
                        name={'data.attributes.sections.' + `${type}.${key}.text_answer`}
                        component={CheckboxUnlabeled}
                        label="Text Answer"
                        labelSize={1}
                        positionTop
                        options={[{ label: '', value: true }]}
                      />
                    </div>
                  )}
                </div>
              </div>
            );
          })}
          <div className="col-sm-12">
            <ButtonBar>
              <Button
                label="New question"
                bsStyle="primary"
                className="pull-right"
                handleClick={() => fields.push()}
              />
              <Button
                label="Delete Last Question"
                bsStyle="primary"
                className="pull-right"
                handleClick={() => fields.pop()}
              />
            </ButtonBar>
          </div>
        </div>
      </div>
    );
  }
}
